import React from "react";

import Measure from "react-measure";
import { useDispatch } from "react-redux";
import { Report } from "reducers/QAReports";
import {
	DataGrid,
	ProgressIndicator
} from "rhombus-react";
import { DEFAULT_ROW_HEIGHT, MIN_GRID_HEIGHT } from "utils/constants";
import { useGridScrollUtils } from "utils/DataGrid";


export default function ReportsGrid({ columns, items, isLoading, sort="" }) {
	const dataGridRef = useGridScrollUtils([items])
		, dispatch = useDispatch()
		, [sortColumn, sortDirection] = sort.split(":")
		;

	function getReportRow(rowId){
		return items[rowId];
	}

	const dataGridProps = {
		columns,
		items,
		rowsCount: items.length,
		rowGetter: getReportRow,
		rowHeight: DEFAULT_ROW_HEIGHT,
		sortColumn,
		sortDirection,
		onGridSort: (col, dir) => dispatch(Report.setSort(col, dir)),
		enableCellAutoFocus: false,
	};

	return (
		<Measure>
			{(obj) => {
				let gridHeight = obj?.contentRect?.entry?.height || MIN_GRID_HEIGHT;
				return (
					<div className="measure-component" ref={obj.measureRef}>
						<ProgressIndicator isLoading={isLoading} />
						<div ref={dataGridRef}>
							<DataGrid {...dataGridProps} minHeight={gridHeight} />
						</div>
					</div>
				);
			}}
		</Measure>
	);
}
